import { EventType } from '@/shared/enums';
import {
  breadcrumbsSchema,
  contactSchema,
  faqSchema,
  homeSchema,
  metaDescription,
  sectionSchema,
  videoSchema,
} from '@/shared/utils/seo';

export default {
  layout({ $router }) {
    return $router.currentRoute.query.webview ? 'simple' : 'default';
  },
  methods: {
    pageLoaded(context) {
      metaDescription(context || { label: this.$route.meta.label });

      this.$spinner.hide();

      const { pos, _route } = this.$router.app;
      this.$nextTick(() => {
        if (pos && !_route.meta.preventScrollHandle) {
          window.scrollTo(pos.x, pos.y);
        } else if (!_route.meta.preventScrollTop) {
          window.scrollTo(0, 0);
        }
      });

      this.$chartbeat.pageView(context);
      this.$stats.pageView(this.$route.fullPath, this.product);
      this.$EventBus.emit(EventType.PAGE_VIEW);
    },
    pageSchema(schema = {}) {
      switch (schema.type) {
        case 'contact':
          contactSchema(schema.document);
          break;
        case 'faq':
          faqSchema(schema.questions);
          break;
        case 'home':
          homeSchema();
          break;
        case 'video':
          videoSchema(schema.product);
          break;
        case 'detail':
          videoSchema(schema.product);
          breadcrumbsSchema(schema.product);
          break;
        default:
          sectionSchema();
      }
    },
  },
};
